import axios from 'axios';
import LocalIP from '../api/LocalIP';
import Cookies from 'js-cookie';

const api = axios.create({
  baseURL: LocalIP,
});


// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = Cookies.get('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


// Response interceptor
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = Cookies.get('refreshToken');
        const response = await axios.put(LocalIP + '/user/refresh', { refreshToken });

        const token  = response.data.data.accessToken;

        Cookies.set('accessToken', token);

        originalRequest.headers.Authorization = `Bearer ${token}`;
        return axios(originalRequest);
      } catch (error) {
          console.error('Error refreshing token:', error);
          window.location.href = '/';
        
      }
    }

    return Promise.reject(error);
  }
);
  
export default api
